@if (model) {
<div class="flex-column bg-col-w ">

    <icms-outlet-block [variant]="model.informationHeaderBlockVariant"
                       [allowOnly]="['hero-banner', 'editorial']" />


    <div class="w-12 flex-column flex-middle flex-justify-center p-r-2 p-l-2 p-a-0-s p-a-0-m w-12-s w-12-m">

        @if(typeData?.showTitle) {
        <h1 class="h1">{{model.data?.name}}</h1>
        }
        <div class="p1 m-t-2"
             *iCms="'topCopy' of typeData; content: 'html'; skipEmpty: true"></div>


        @if(client.isX || client.isL){
        <div class="m-t-10 w-12 wrap bg-col-w">
            <icms-outlet [components]="components"
                         [allowOnly]="allowedComponents" />

        </div>
        }
    </div>

    @if(client.isM || client.isS){
    <div class="m-t-5 wrap bg-col-w">
        <icms-outlet [components]="components"
                     [allowOnly]="allowedComponents" />
    </div>
    }
</div>
@if(typeData) {
<icms-outlet-block [variant]="model.informationContentBlockVariant"
                   [name]="'Information content'" />
}
}